import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/styles";
import { useIntl } from "react-intl";
import { StyledSkeleton } from "components/LoadingComponent/LoadingComponent.styles";

const ViewTargetBlock = ({ targetName, isLoading }) => {
  const { formatMessage } = useIntl();

  const theme = useTheme();
  return (
    <Box
      sx={{
        background: theme.customColors.purple[400],
        padding: "16px",
        borderRadius: "4px",
        height: "80px",
      }}
    >
      <Box
        sx={{ fontSize: "16px", marginBottom: "8px" }}
        color={(theme) => theme.customColors.purple[500]}
      >
        {formatMessage({ id: "communityAnalysis.instance.labelName" })} :
      </Box>
      <Box
        sx={{ fontSize: "18px", fontWeight: "700" }}
        color={(theme) => theme.customColors.purple[500]}
      >
        {isLoading ? (
          <StyledSkeleton
            animation="wave"
            sx={{ height: "24px", width: "80%" }}
          />
        ) : (
          targetName
        )}
      </Box>
    </Box>
  );
};

export default ViewTargetBlock;
